import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86d6e336"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirmation-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle mr-3",
  style: {"font-size":"2rem"}
}, null, -1))

import { ref, watch, onMounted } from 'vue';
import i18n from '@/locale/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteConfirmDialog',
  props: {
    showFlag: {
        type: Boolean,
        default: false
    }
},
  emits: ["hideDeleteDialog", "doDelete"],
  setup(__props, { emit }: { emit: ({
  (event: 'hideDeleteDialog', data: { event: MouseEvent }): void;
  (event: 'hideDeleteDialog' ): void;
  (event: 'doDelete', data: { event: MouseEvent }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const t = i18n.global.t;

const displayFlag = ref();





const hideDeleteDialog = (event: MouseEvent) => {
    emit('hideDeleteDialog', { event });
}

const doDelete = (event: MouseEvent) => {
    emit('doDelete', { event });
}

onMounted(() => {
    displayFlag.value = props.showFlag;
})

watch(() => props.showFlag, (newVal, oldVal) => {
    displayFlag.value = newVal;
})

const hideEvent = () => {
    emit('hideDeleteDialog');
}


return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: displayFlag.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((displayFlag).value = $event)),
    header: _unref(t)("COMMON.DIALOG.CONFIRMATION"),
    breakpoints: { '960px': '75vw', '640px': '90vw' },
    style: { width: '450px' },
    modal: true,
    onHide: hideEvent
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: _unref(t)("COMMON.BUTTON.CANCEL"),
        class: "p-button-secondary",
        icon: "pi pi-times",
        onClick: hideDeleteDialog
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        label: _unref(t)("COMMON.BUTTON.DELETE"),
        class: "p-button-danger",
        icon: "pi pi-check",
        onClick: doDelete
      }, null, 8, ["label"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_unref(t)("COMMON.DIALOG.CONFIRM_MESSAGE_DELETE")), 1)
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}
}

})